import { useTranslation } from 'react-i18next';
import Icon from 'components/Icon';
import { LinkHasExpiredIcon } from '../assets';
import { Wrapper, Header, Container, Img, Title, Description, Supporter } from './index.view';

const LinkHasExpired = () => {
  const { t } = useTranslation();
  const contactEmail = () => <Supporter href="mailto:support@fanz.io">support@fanz.io.</Supporter>;
  return (
    <Wrapper>
      <Header>
        <Icon name="logo" />
      </Header>
      <Container maxWidth="md">
        <Img src={LinkHasExpiredIcon} alt="LinkHasExpired" />

        <Title>{t('linkHasExpiredTitle')}</Title>

        <Description>
          {t('linkHasExpiredDesc')}
          {contactEmail()}
        </Description>
      </Container>
    </Wrapper>
  );
};

export default LinkHasExpired;
